import {
    NavController,
    NavParams,
    App,
    ModalController,
    ViewController,
    ToastController,
  } from "ionic-angular";
  import { Storage } from "@ionic/storage";
  import { Component, OnInit, Input } from "@angular/core";
  
  import { AuthProvider } from "../../../../../providers/auth/auth";
  import { EmployeeRhProvider } from "../../../../../providers/employeerh/employeerh";
  import { GoalRhProvider } from "../../../../../providers/goals/goals";
  
  @Component({
    selector: "page-rh-goals-assign",
    templateUrl: "goals-assign-list.html",
  })
  export class RhGoalsAssignList implements OnInit {
    goalsLists:any = null;
    selectedList:any = null;

    assignableUsers:any = null;
    selectedUsers:any = null;
  
    constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public storageProvider: Storage,
      public app: App,
      public authProvider: AuthProvider,
      public employeeRhProvider: EmployeeRhProvider,
      public viewCtrl: ViewController,
      public toastCtrl: ToastController,
      private goalRhProvider: GoalRhProvider
    ) {}
  
    ngOnInit() {
      this.loadDatas();
    }
  
    loadDatas() {
      this.goalRhProvider.getGoalsList().subscribe((res) => {
        if(res.success){
          this.goalsLists = res.data;
        }
      })

      this.goalRhProvider.getAssignableUsers().subscribe((res) => {
        if(res.success){
          this.assignableUsers = res.data;
        }
      })
    }

    assignListToUsers(){
      this.goalRhProvider.assignListToUsers(this.selectedList.id, this.selectedUsers).subscribe((res) => {
        if(res.success){
          let toast = this.toastCtrl.create({ message: "Les objectifs sont désormais assignés et en attente de signature", duration: 6000, position: 'top'});
          toast.present();
          this.dismiss();
        }
      })
    }
  
    // Modal ctrl
    dismiss() {
      this.viewCtrl.dismiss();
    }
  }
  


// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-goals/goals-assign-list/goals-assign-list.ts